const GEOAPIFY_API_KEY = process.env.REACT_APP_GEOAPIFY_KEY;

const GeoapifyConfig = {
  API_KEY: GEOAPIFY_API_KEY,
  BASE_URL: 'https://api.geoapify.com/v1',
};

export default GeoapifyConfig;
